import React from 'react'
import Lottie from "lottie-react"
function LottieAnimation({name, className=""}) {
  const lottieData=require(`../images/animations/${name}.json`)
  return (
    <Lottie animationData={lottieData} loop={true} className={className}/>
  )
}

export default LottieAnimation;